import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import cx from 'classnames';
import { getAnimationDuration } from './helpers';
import * as styles from './style.css';
import { jsx as _jsx } from "react/jsx-runtime";
/* Компонент бегущей строки */
export var Ticker = function Ticker(_ref) {
  var text = _ref.text,
    withBackground = _ref.withBackground;
  var wrapperRef = React.useRef(null);
  var tickerRef = React.useRef(null);
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    animationDuration = _React$useState2[0],
    setAnimationDuration = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isInfinite = _React$useState4[0],
    setInfinite = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isStatic = _React$useState6[0],
    setStatic = _React$useState6[1];
  React.useEffect(function () {
    var time = getAnimationDuration(tickerRef.current, wrapperRef.current);
    if (!time) {
      setStatic(true);
    } else {
      setStatic(false);
      setAnimationDuration(time);
    }
  }, [text, isInfinite]);
  var onAnimationEnd = React.useCallback(function () {
    setInfinite(true);
  }, []);
  return /*#__PURE__*/_jsx("div", {
    ref: wrapperRef,
    className: cx(styles['container'], withBackground && styles['container--with-background']),
    children: /*#__PURE__*/_jsx("div", {
      ref: tickerRef,
      style: {
        animationDuration: "".concat(animationDuration, "s"),
        WebkitAnimationDuration: "".concat(animationDuration, "s")
      },
      onAnimationEnd: onAnimationEnd,
      className: cx(styles['ticker'], isInfinite && styles['ticker--infinite'], isStatic && styles['ticker--static']),
      children: /*#__PURE__*/_jsx("div", {
        className: styles['text'],
        children: text
      })
    })
  });
};